import { PaginationData } from "src/types/api";
import { baseInstance } from "..";

export const getEventsFilter = async (payload: PaginationData) => {
  try {
    return await baseInstance.get(
      `events/filter/?page=${payload.page}&page_size=${payload.size}`
    );
  } catch (err: any) {
    return err;
  }
};
